export class StorageObject {
	constructor(prefix) {
		this.prefix = prefix;
	}

	get(key, def = null) {
		let data = localStorage.getItem(this.prefix + key);
		return data ? JSON.parse(data) : def;
	}

	set(key, value) {
		localStorage.setItem(this.prefix + key, JSON.stringify(value));
	}
}

export default StorageObject;